











































































































import { Component, Vue } from 'vue-property-decorator';
import { Search } from '@/data/models/search.model';
import store, { State } from '@/store';
import { Actor } from '@/data/models/actor.model';
import { Veicolo } from '@/data/models/veicolo.model';
import { date2Num, dateEndofDay, newDate } from '@/data/utils/helper';
import { ClassType } from 'class-transformer/ClassTransformer';
import { Contatto } from '@/data/models/contatto.model';

@Component
export default class ServizioPeriodicoFilter extends Vue {

	advancedSearch: Search;
	veicoloClass: ClassType<Veicolo> = Veicolo;
	veicoloSearch: Search = new Search('vehicle');
	actorClass: ClassType<Actor> = Actor;
	actorSearch: Search = new Search('actor');
	operatoreClass: ClassType<Actor> = Actor;
	operatoreSearch: Search = new Search('actor');
	payerClass: ClassType<Actor> = Actor;
	payerSearch: Search = new Search('actor');

	searchParam: any = new class {
		periodstartdate?: Date[];
		periodenddate?: Date[];
		vehicle?: Veicolo;
		operatore?: Actor;
		patient?: Actor;
	};

	state!: State;

	constructor() {
		super();
		this.state = store;
		this.advancedSearch = new Search('periodicservice');
		this.actorSearch.addNotEqualFilter('patientid', null);
		this.actorSearch.addSimpleFilter('hqid', this.state.headquarter!.id);
		this.payerSearch.addSimpleFilter('hqid', this.state.headquarter!.id);
		this.veicoloSearch.addSimpleFilter('hqid', this.state.headquarter!.id);
		this.operatoreSearch.addSimpleFilter('hqid', this.state.headquarter!.id);
		this.operatoreSearch.addSimpleFilter('candrive', 1);
		this.operatoreSearch.addNotEqualFilter('volunteerid', null);
	}

	search() {
		this.advancedSearch.reset();

		this.advancedSearch.addSimpleFilter('hqid', this.state.headquarter!.id);

		if (this.searchParam.periodstartdate && this.searchParam.periodstartdate.length) {
			const start = this.searchParam.periodstartdate[0] ? date2Num(this.searchParam.periodstartdate[0]) : 0;
			const end = this.searchParam.periodstartdate[1] ? date2Num(dateEndofDay(this.searchParam.periodstartdate[1])) : newDate(true).getTime();
			this.advancedSearch.addRangeFilter('periodstartdate', start as number, end as number);
		}

		if (this.searchParam.periodenddate && this.searchParam.periodenddate.length) {
			const start = this.searchParam.periodenddate[0] ? date2Num(this.searchParam.periodenddate[0]) : 0;
			const end = this.searchParam.periodenddate[1] ? date2Num(dateEndofDay(this.searchParam.periodenddate[1])) : newDate(true).getTime();
			this.advancedSearch.addRangeFilter('periodenddate', start as number, end as number);
		}
		
		if (this.searchParam.operatore && this.searchParam.operatore.id) this.advancedSearch.addSimpleFilter('driverid', this.searchParam.operatore.id);
		if (this.searchParam.vehicle && this.searchParam.vehicle.id) this.advancedSearch.addSimpleFilter('vehicleid', this.searchParam.vehicle.id);
		if (this.searchParam.patient && this.searchParam.patient.id) this.advancedSearch.addSimpleFilter('patientid', this.searchParam.patient.id);
		if (this.searchParam.payer && this.searchParam.payer.id) this.advancedSearch.addSimpleFilter('payerid', this.searchParam.payer.id);

		this.$emit('search', this.advancedSearch);
	}

	reset() {
		this.searchParam.periodstartdate = [];
		this.searchParam.periodenddate = [];
		this.searchParam.vehicle = {};
		this.searchParam.operatore = {};
		this.searchParam.patient = {};
		this.searchParam.payer = {};
		
		this.search();
	}

	contactFormatter = (contact: Contatto) => {
		if(contact.id) {
			return `${contact.fullname} - ${contact.address ? contact.address : ''} ${contact.streetno ? contact.streetno : ''}`;
		}
	}

	operatoreFormatter = (contact: Contatto) => {
		if(contact.id) {
			return `${contact.fullname} - ${contact.landline ? contact.landline : contact.mobile}`;
		}
	}

}
